// BASIC:
import React from "react"
import "./style.sass"

// UTILITIES:

import { SalihContext } from "../../context/salih.context"

// COMPONENTS:
const SocialLinksNav = () => {
  const { socialLinks } = React.useContext(SalihContext)
  return (
    <nav className="social-nav-wrapper">
      <ul className="social-links">
        {socialLinks.map(({ url, icon, bkg }) => (
          <li>
            <a href={url} target="_blank" rel="noopener noreferrer">
              {icon}
            </a>
          </li>
        ))}
      </ul>
      {/*<p className="contact-with-number">*/}
      {/*  <span className="symbol">tel: </span>*/}
      {/*  <a href="tel:+201096477631" className="phone">*/}
      {/*    +20 1096477631*/}
      {/*  </a>*/}
      {/*</p>*/}
    </nav>
  )
}

export default SocialLinksNav
